enum Modals {
  changeEmail = 'changeEmail',
  whyNow = 'whyNow',
  checkout = 'checkout',
  skipTrial = 'skipTrial',
  expiredOffer = 'expiredOffer',
  trialPrice = 'trialPrice',
  trialGuarantee = 'trialGuarantee',
  newCheckout = 'newCheckout',
  upgradeModal = 'upgradeModal',
}

export default {
  [Modals.changeEmail]: {
    component: 'LazyChangeEmailAddress',
    props: { transition: { name: 'slide-bottom' } },
  },
  [Modals.checkout]: {
    component: 'LazyPaymentForm',
    props: { transition: { name: 'slide-bottom' } },
  },
  [Modals.whyNow]: {
    component: 'LazyWhyNowModal',
    props: { transition: { name: 'fade' } },
  },
  [Modals.skipTrial]: {
    component: 'LazySkipTrialModal',
    props: { transition: { name: 'fade' } },
  },
  [Modals.expiredOffer]: {
    component: 'LazyExpiredOfferModal',
    props: { transition: { name: 'fade' } },
  },
  [Modals.trialPrice]: {
    component: 'LazyChooseTrialPrice',
    props: { transition: { name: 'fade' }, selfClick: false },
  },
  [Modals.trialGuarantee]: {
    component: 'LazyTrialGuaranteeModal',
    props: { transition: { name: 'fade' }, selfClick: false },
  },
  [Modals.newCheckout]: {
    component: 'LazyNewCheckoutModal',
    props: { transition: { name: 'slide-bottom' } },
  },
  [Modals.upgradeModal]: {
    component: 'LazyUpgradeModal',
    props: { transition: { name: 'fade' }, selfClick: false },
  },
};
